import { filterChecks } from "@/utils/dataConvert";
import {toUrl} from "@/utils/textUtilities";
import {isFalse, isTrue} from "@/utils/service/DocumentGeneration/answers";
import inputRules from "@/utils/inputRules";

export function transform(model) {
    const include = [];
    const finalObject = {
        company: model.company,
        website_url: toUrl(model.website_url),
        collected_data: {
            account_signup_info: filterChecks(
                model.collected_data.account_signup_info
            ),
            communication_data: !!model.collected_data.communication_data.length,
            payment_info: filterChecks(model.collected_data.payment_info),
            login_info: filterChecks(model.collected_data.login_info),
            other_info: model.collected_data.other_info,
        },
        automatically_collected_data: {
            device_log_data: filterChecks(
                model.automatically_collected_data.device_log_data
            ),
            device_os_info: [],
            tracking: filterChecks(model.automatically_collected_data.tracking),
            geo_data: model.automatically_collected_data.other.geo_data,
            usage_info: model.automatically_collected_data.other.usage_info,
            personal_info:
                model.automatically_collected_data.other.personal_info,
            other_info: model.automatically_collected_data.other_info,
        },
        unsubscribe: {
            email:
                model.direct_marketing.unsubscribe.unsubscribe_email ||
                model.company.policy_email,
            options: model.direct_marketing.unsubscribe,
        },
        info_usage: model.info_usage,
        info_usage_other: model.info_usage_other,
        third_parties: model.third_parties || [],
        cookies: model.cookies,
        tos_link: model.tos_link,
        gdpr: false,
        gdpr_representative: model.gdpr_representative,
        retention: model.retention
    };

    if (isTrue(model.haveTOS)) {
        include.push("policy_by_tos")
        if(model.tos_link === "include_website_tos_from_project") {
            finalObject['include_website_tos_from_project'] = true;
            finalObject.tos_link = "";
        } else {
            finalObject.tos_link = toUrl(model.tos_link);
        }
    } else if (
        isFalse(model.haveTOS) &&
        model.tos_no_use_create
    ) {
        include.push("policy_by_tos");
        finalObject['include_website_tos_from_project'] = true;
    }

    if (isTrue(model.cookies.used)) {
        if(model.cookies.policy_link === "include_cookie_policy_from_project") {
            finalObject['include_cookie_policy_from_project'] = true;
        }
    }

    // gdpr
    if (model.gdpr.use1 || model.gdpr.use2) {
        include.push("gdpr");
        finalObject.gdpr = true;
    }
    // info_from_minors
    if (model.minors_information) include.push("info_from_minors");
    // sensitive_info
    if (model.sensitive_information) include.push("sensitive_info");
    // payment_info
    if (model.payment_processor.use) {
        include.push("payment_info");
        finalObject.payment_info = {
            use: model.payment_processor.use,
            use_payment_processors:
                model.payment_processor.use_payment_processors,
            payment_processors: model.payment_processor.payment_processors,
        };
    }
    // third_party_links
    if (model.third_party_links) include.push("third_party_links");
    // security
    if (model.security) include.push("security");
    // direct_marketing
    if (model.direct_marketing.use) include.push("direct_marketing");
    // third_party_info_sharing
    if (model.third_parties.length > 0)
        include.push("third_party_info_sharing");

    finalObject.include = include;

    return finalObject;
}

export function retransform(params) {
    let final = {};

    final.haveTOS = params.include;

    // policy_by_tos
    final.haveTOS = !!params.include.includes("policy_by_tos");
    final.tos_link = params.tos_link;
    // gdpr
    final.gdpr = {
        use1: !!params.include.includes("gdpr"),
        use2: false,
    }
    // info_from_minors
    final.minors_information = !!params.include.includes("info_from_minors");
    // sensitive_info
    final.sensitive_information = !!params.include.includes("sensitive_info");
    // third_party_links
    final.third_party_links = !!params.include.includes("third_party_links");
    // security
    final.security = !!params.include.includes("security");

    if(params.retention.main) {
        final.retention = params.retention;
    } else {
        let tempRetention = {...params.retention};
        delete tempRetention.other_cases;

        const mainRetentionStrategy = Object.entries(tempRetention).find(([key, value]) => value === true);

        final.retention = {
            main: mainRetentionStrategy?.shift(),
            other_cases: params.retention.other_cases,
        };
    }

    if (params.payment_info) {
        final.payment_processor = {
            use: params.payment_info.use,
            use_payment_processors: params.payment_info.use_payment_processors,
            payment_processors: params.payment_info.payment_processors,
        };
    }

    return {
        ...params,

        ...final,

        gdpr_representative: params.gdpr_representative,
        automatically_collected_data: {
            tracking: params.automatically_collected_data.tracking,
            device_log_data:
                params.automatically_collected_data.device_log_data,
            other: {
                geo_data: params.automatically_collected_data.geo_data,
                usage_info: params.automatically_collected_data.usage_info,
                personal_info:
                    params.automatically_collected_data.personal_info,
            },
            other_info: params.automatically_collected_data.other_info,
        },

        // Direct Marketing
        direct_marketing: {
            use: !!params.include.includes("direct_marketing"),
            unsubscribe: {
                unsubscribe_email: params.unsubscribe.options.unsubscribe_email,
                ...params.unsubscribe.options,
            },
        },

        "third_parties.use": params.third_parties.length > 0,
        third_parties: params.third_parties,

        cookies: params.cookies
    };
}
